// removed by extract-text-webpack-plugin
module.exports = {"row":"TableSelectionGroup__row","selected":"TableSelectionGroup__selected","success":"TableSelectionGroup__success","tableFixed":"TableSelectionGroup__tableFixed","partRow":"TableSelectionGroup__partRow","scrollable":"TableSelectionGroup__scrollable","recommended":"TableSelectionGroup__recommended"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TableSelectionGroup/TableSelectionGroup.scss
// module id = ./src/components/TableSelectionGroup/TableSelectionGroup.scss
// module chunks = 2